// extracted by mini-css-extract-plugin
module.exports = {"zeroCodonationMessage":"ZeroCodonationMessage_zeroCodonationMessage__cXve4"};